import { useEffect, useRef } from 'react';
const useCloseOnEscape = (handler, element) => {
    const savedHandler = useRef();
    if (!element) {
        return;
    }
    useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);
    useEffect(() => {
        const eventListener = (event) => {
            if (event.key === 'Escape' && savedHandler.current) {
                savedHandler.current(event);
            }
        };
        if (!element.current) {
            return;
        }
        // Add event listener
        element.current.addEventListener('keyup', eventListener);
        // Remove event listener on cleanup
        return () => {
            element.current &&
                element.current.removeEventListener('keyup', eventListener);
        };
    }, [element]);
};
export { useCloseOnEscape };
